import { autoinject } from "aurelia-dependency-injection";
import { EmailRecipientTypeEnum } from "../../../../../../../../models/vetting/vetting.models";
import { BaseEnvironmentalVerificationTab } from "../base-environmental-verification-tab";
import { useView } from "aurelia-framework";

type VerifyOption = { id: number, name: string, isSelected: boolean };

@autoinject
@useView('views/pages/modules/ghg/pages/request-an-environmental-verification/tabs/environmental-verification-basic/environmental-verification-basic.html')
export class EnvironmentalVerificationBasic extends BaseEnvironmentalVerificationTab {

    get isVesselDetailsOrEEXISelected() {
        // If at least 1 verifyOption is selection from the first two options (Vessel Details & EEXI)
        return this.verifyOptions.filter(verifyOption => verifyOption.id<3 && verifyOption.isSelected).length > 0;
    }

    removeEmail(i) {
        const list = this.correspondenceEmails;

        if (i == 0) {
            list[i].email = "";
            list[i]["canEdit"] = true;
        } else
            list.splice(i, 1);
    }

    addEmail() {
        this.correspondenceEmails.push({
            email: "",
            emailRecipientTypeId: EmailRecipientTypeEnum.To,
            canEdit: true,
            isFrom: true,
            isFromConfig: false,
            isInspectingCompanyEmail: false,
            isShipManagerEmail: false,
            isTechnicalManagerEmail: false
        });
    }

    /**
     * When a verifyOption's isSelected status is changed, make sure only one verification option
     * from the 'Vessel Details' and 'EEXI' is selected at a single point in time
     * @param verifyOption (un)Selected verifyOption
     */
    onVerificationOptionToggled(verifyOption: VerifyOption) {
        const evdiOption = this.verifyOptions[0];
        const eexiOption = this.verifyOptions[1];

        if (evdiOption.isSelected && eexiOption.isSelected) {
            if (verifyOption.id === evdiOption.id) eexiOption.isSelected = false;
            else evdiOption.isSelected = false;
        }
    }
}